import { render } from "./ProsecutorView.vue?vue&type=template&id=2b4c1474"
import script from "./ProsecutorView.vue?vue&type=script&lang=js"
export * from "./ProsecutorView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__